<script>
    import { createEventDispatcher } from "svelte";

    export let image;
    export let selected;
    export let editable;

    const dispatch = createEventDispatcher();

    function toggle () {
        dispatch("toggle", { image });
    }

    function del () {
        dispatch("del", image);
    }
</script>

<button class:selected={selected} on:click={toggle}>
    {#if editable}
        <button class="delete" on:click|stopPropagation={del}>🗑️</button>
    {/if}
    <img src={image.src} alt="" width="100" height="100">
</button>

<style>
    button {
        padding: 0;
        font-size: 0;
        background-color: transparent;
        border-radius: 0.2rem;
        overflow: hidden;
        line-height: initial;
        padding: 2px;
        position: relative;
    }

    .delete {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 1rem;
    }

    img {
        width: 100%;
        height: auto;
    }

    button.selected {
        outline: 2px solid #6BBE7D;
    }
</style>
